import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function Educational() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="about__body dvsim">
          <div className="title__about">
            <h1>O'zbekiston-Rossiya ta'lim fakulteti </h1>
          </div>
          <p>
            <span>
              O'zbekiston-Rossiya ta'lim fakulteti v.v.b. dekani
              <br />
              Hashirbaeva Dinora Makkambaevna
              <br />
              Tibbiyot fanlari doktori, DSc
              <br />
              Qabul kunlari: har kuni 14:00-17:00
              <br />
              E-mail: dkhashirbaeva@mail.ru
              <br />
              Telefon: 90-947-29-29
            </span>
            <span>
              O'zbekiston Respublikasi "Ta'lim to'g'risida", "Kadrlar tayyorlash
              milliy dasturi to'g'risida" qonunlariga muvofiq Rossiya
              Federatsiyasining "Ta'lim to'g'risida" gi qonuni, Toshkent
              farmatsevtika instituti va Sankt-Peterburg Davlat
              kimyo-farmatsevtika universiteti o'rtasida tuzilgan
              20.10.2018-yildagi "Memorandum" ga asosan 15.11.2018-yildan
              2-sonli qo'shimcha bitimga muvofiq, Qo'shma ta'lim dasturi
              (hozirgi O'zbek-Rossiya ta'lim fakulteti) tashkil etildi. Ushbu
              dastur 2019-yilda Toshkent farmatsevtika instituti (O'zbekiston)
              va Rossiya federatsiyasi sog'liqni saqlash vazirligining
              "Sankt-Peterburg davlat kimyo-farmatsevtika universiteti" oliy
              ta'lim Federal davlat byudjet ta'lim muassasasi o'rtasida tashkil
              etilgan. Ikki tomon o'rtasida tasdiqlangan bakalavriat ta'lim
              dasturiga muvofiq talabalar 5510500-Farmatsiya yo'nalishi bo'yicha
              tahsil olmoqda. Dastur ikki tomon qoidalariga muvofiq, tegishli
              hisob-kitob birliklarini (reyting ballarini) olish va o'zaro
              taqsimlash bilan bakalavr (mutaxassislik) bo'yicha o'qishni o'z
              ichiga oladi. Dasturning davomiyligi 5 yil (10 semestr). Ushbu
              dasturning maqsadi bakalavr (mutaxassislik) ning shu kabi
              yo'nalishlari bo'yicha kadrlar tayyorlash, kelishilgan tomonlar,
              bilim, ko'nikma va ko'nikmalarni takomillashtirish, tajriba
              almashish, ta'limni xalqarolashtirish, akademik mobillikni
              kengaytirish, bakalavr (mutaxassislik) tomonidan olib borilayotgan
              ilmiy tadqiqotlar sifatini oshirishdan iborat. Bakalavriat
              (mutaxassislik) bo'yicha ta'lim jarayoni kunduzgi shaklda amalga
              oshiriladi, shundan so'ng shu kabi ta'lim yo'nalishlari bo'yicha
              ikkita diplom beriladi. Stipendiyalarni to'lash nazarda
              tutilmaydi, biroq muayyan yutuqlar uchun, shu jumladan, yaxshi
              ilmiy yutuqlar, olimpiadalar, ilmiy anjumanlarda ishtirok etish,
              shuningdek, fakultet va institutning ijtimoiy-madaniy tadbirlarida
              faol ishtirok etish uchun rag'batlantiruvchi davlat stipendiyalari
              talab qilinadi. O'zbekiston-Rossiya ta'lim fakultetida o'qish
              "3+2" algoritmiga muvofiq amalga oshiriladi, birinchi 3 yilda
              talabalar Toshkent farmatsevtika institutida, keyingi 2 yilda
              Sankt-Peterburg davlat kimyo-farmatsevtika universitetida FGBOUDA
              tahsil olishadi.
            </span>
            <span>
              2020-yilda 02-oktabr kuni Toshkent farmatsevtika institutining
              yangi tuzilmasini tasdiqlash chog'ida O'zbekiston-Rossiya ta'lim
              fakulteti hamda fakultet qoshida gumanitar, tabiiy va
              farmatsevtika fanlari kafedrasi tashkil etildi. Kafedraga DAKT
              rahbarlik qiladi.asal.Fanlar Hashirbaeva Dinora Makkambaevna.
              Kafedrada 25 nafar professor – o'qituvchilar o'z pedagogik
              faoliyatlarini olib borishadi: ulardan 3 nafari professor, 10
              nafari dotsent, 7 nafari katta o'qituvchi va 5 nafar assistent.
              Ilmiy salohiyat 61% ni tashkil etadi. Kafedraning asosiy tarkibi:
            </span>
            <span>
              – Xashirbaeva Dinora Makkambaevna-bosh.kafedra mudiri, t. f. D.;
              <br />
              - Voronina Natalya Vladimirovna-kafedra dotsenti, t. f. D.;
              <br />
              - Soliboyeva Sevara Olimjonovna-kafedra assistenti;
              <br />
              - Raximova Guljan Otabekovna-kafedra assistenti;
              <br />
              - Jalilova Dildora Sheraliyevna-kafedra assistenti;
              <br />- Sabirov Dilshod Shuxra o'g'li-kafedra assistenti.
            </span>
            <span>
              Bugungi kunda fakultetda 137 nafar talaba tahsil olmoqda.
              Fakultetning barcha talabalari va kafedra professor-o'qituvchilari
              Sankt-Peterburg Davlat kimyo-farmatsevtika universitetining
              elektron kutubxonasiga a'zo. Talabalar tomonidan materiallarni
              muvaffaqiyatli o'zlashtirish uchun fanlar bo'yicha barcha zarur
              kitoblar sotib olinib, har yili universitetning yetakchi
              mutaxassislari tomonidan onlayn darslar o'tkaziladi. Hozirgi
              vaqtda talabalarning kitoblarning elektron versiyalari bilan
              ta'minlanishi 100% ni tashkil etadi.
            </span>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Educational;
